import { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const TawkToChat = () => {
  const { language } = useLanguage();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Don't load twice
    if (loaded) return;
    if (document.querySelector('script[src*="tawk.to"]')) return;

    // Fetch settings and load
    fetch(`${BACKEND_URL}/api/chat-settings`)
      .then(res => res.json())
      .then(settings => {
        console.log('[TawkTo] Settings:', settings);
        
        if (!settings?.enabled || !settings.tawk_property_id) {
          console.log('[TawkTo] Disabled or missing config');
          return;
        }

        // Select widget based on language: FR, AR or EN
        let widgetId;
        if (language === 'fr') widgetId = settings.tawk_widget_id_fr;
        else if (language === 'ar') widgetId = settings.tawk_widget_id_ar;
        else widgetId = settings.tawk_widget_id_en;
        
        if (!widgetId) {
          console.log('[TawkTo] No widget ID for language:', language);
          return;
        }

        console.log('[TawkTo] Injecting script for:', language, widgetId);
        
        // Standard Tawk.to embed
        window.Tawk_API = window.Tawk_API || {};
        window.Tawk_LoadStart = new Date();

        // Position: LEFT for Arabic (RTL), RIGHT for others
        if (language === 'ar') {
          window.Tawk_API.customStyle = {
            visibility: {
              desktop: { position: 'bl', xOffset: 20, yOffset: 20 },
              mobile: { position: 'bl', xOffset: 10, yOffset: 10 }
            }
          };
        }

        const s1 = document.createElement('script');
        s1.async = true;
        s1.src = `https://embed.tawk.to/${settings.tawk_property_id}/${widgetId}`;
        s1.charset = 'UTF-8';
        
        s1.onload = () => console.log('[TawkTo] ✅ Loaded');
        s1.onerror = () => console.log('[TawkTo] ❌ Failed');
        
        const s0 = document.getElementsByTagName('script')[0];
        s0.parentNode.insertBefore(s1, s0);
        
        setLoaded(true);
      })
      .catch(err => console.error('[TawkTo] Error:', err));
  }, [loaded, language]);

  return null;
};

export default TawkToChat;
